import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40ac801c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['sidebar-section'])
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: item.key,
      onClick: $event => $options.handleChange(item),
      class: _normalizeClass(['item', {
        active: item.key === $props.modelValue
      }])
    }, _toDisplayString(item.name), 11, _hoisted_3)), [[_vShow, !item.skip]]);
  }), 128))]);
}